import { PartnerDashboard } from 'types/partnerDashboardTypes';

export const createPartnerDashboard = (): PartnerDashboard => ({
  trialClients: [],
  trialClientsInvalidated: false,
  paidClientGroups: [],
  paidClientGroupsInvalidated: false,
  cancelledClients: [],
  cancelledClientsInvalidated: false,
});
